import Config from 'config';
import React from 'react';
import useContext from '../../../../hooks/useContext';
import { formatMessage } from '../../../../utils/util';
import { ApiaInputContext } from './ApiaInput';
import FieldContext from '../fieldsStore/FieldContext';
import { NumberApiaInputPrimitive } from './NumberApiaInputPrimitive';

const NumberApiaInput = () => {
  const inputProps = useContext(ApiaInputContext);
  const {
    setError,
    setValue,
    fireEvent,
    state: { value },
  } = useContext(FieldContext);

  return (
    <NumberApiaInputPrimitive
      {...inputProps}
      value={value as string}
      onChange={React.useCallback(
        ({ error, newValue }: { error?: string; newValue?: string }) => {
          fireEvent('onChange');
          if (error) {
            setValue(newValue, { avoidCleanError: true });
            setError(formatMessage(Config.GNR_NUMERIC, { TOK: '' }), '');
          } else {
            setValue(newValue);
          }
        },
        [fireEvent, setError, setValue],
      )}
    />
  );
};

export default NumberApiaInput;
